module.exports = __webpack_public_path__ + "static/media/mortgage-rent-lease.56f0c969.svg";